export default "__VITE_ASSET__CIxfiFCj__"